const mixin = {
    data: ()=>{
        return {
            ui:{
                loading: false,
                modal: {
                    show: false,
                    message: ''
                },
                lightbox: {
                    show: false,
                },
                thanks: false
            },
            styleObject: {
                'min-height': (function(){
                    var header = document.querySelector('.eltdf-mobile-header-holder');
                    var height = window.innerHeight - header.clientHeight;
                    return height + 'px';
                })(),
            },
            type: window.mpsType ? window.mpsType : 'guest',
            workshopUserId: window.mpsWorkshopUserId ? window.mpsWorkshopUserId : undefined,
            workshopId: window.mpsWorkshopId ? window.mpsWorkshopId : undefined,
            adminUserId: window.mpsAdminUserId ? window.mpsAdminUserId : undefined,
            companyId: window.mpsCompanyId ? window.mpsCompanyId : undefined,
            companyUserId: window.mpsCompanyUserId ? window.mpsCompanyUserId : undefined,
            redirect: window.mpsRedirect ? window.mpsRedirect : null
            /*
            partnerId: window.mpsPartnerId ? window.mpsPartnerId : undefined,

            fleet: window.mpsFleet ? window.mpsFleet : undefined,
            fleetId: window.mpsFleetId ? window.mpsFleetId : undefined,
            
            fleetpartnerId: window.fleetpartnerId ? window.fleetpartnerId : undefined,
            */
        }
    },
    methods:{
        showUILightbox: function(){
            document.body.classList.add('lightbox-opened')
            this.ui.lightbox.show = true;
        },
        hideUILightbox: function(){
            setTimeout(function(){
                document.body.classList.remove('lightbox-opened')
            }, 350);
            this.ui.lightbox.show = false;
        },
        isAdminPage: function(){
            return this.type == 'admin';
        },
        isWennApiPage: function(){
            return this.type == 'wenn';
        },
        isFleetPage: function(){
            return this.type == 'fleet' || this.fleet;
        },
        isCompanyPage: function(){
            return this.type == 'company';
        },
        isWorkshopPage(){
            return this.workshopId;
        },
        isGuestPage: function(){
            return this.type == 'guest';
        },
        showModal: function(message){
            this.ui.modal.message = message;
            this.ui.modal.show = true;
        },
        isWorkshopUser(){
            return this.workshopUserId && this.workshopUserId.length;
        },
        isAdminUser(){
            return this.adminUserId;
        },
        isWorkshopCapability(){
            return this.isAdminUser() || this.isWorkshopUser();
        },
        isCompanyUser(){
            return this.companyUserId;
        },
        getCookie(name){
            var matches = document.cookie.match(new RegExp(
                "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
            ));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        },
        /*
        isPartner: function(){
            return this.partnerId;
        },
        isFleet: function(){
            return this.fleet;
        },

        setFleetId: function(id){
            this.fleetId = id;
        },
        */
        messageBox(message, title, options){

            //return MessageBox.confirm(message, title, options)
        }
    },
    created: function(){
        this.styleObject.display = 'block';
    }
}
export default mixin


// WEBPACK FOOTER //
// ./requests/assets/src/mixins/ui.js